import { UserRole } from '~/types';

export const userTypeOptions = [
  {
    value: UserRole.HealthManager,
    label: 'Health Manager',
  },
  {
    value: UserRole.ProgramAdmin,
    label: 'Program Admin',
  },
  {
    value: UserRole.SuperAdmin,
    label: 'Super Admin',
  },
];

export const userRoleOptions = [{ value: '', label: 'All Users' }, ...userTypeOptions];
